module.exports = __webpack_public_path__ + "img/MX-A018030B-AS-HQ.b90c7d37.png";